import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import Experience from "./Experience/Experience.js";

gsap.registerPlugin(SplitText);

const experience = new Experience(document.querySelector("canvas.webgl"));

const loadingText = document.querySelector(".loading-text");
if (loadingText) {
    const split = new SplitText(loadingText, { type: "chars" });
    gsap.from(split.chars, {
        opacity: 0,
        y: 10,
        stagger: 0.01,
        ease: "power2.out",
        // fixing FOUC: https://gsap.com/community/forums/topic/45122-avoid-fouc-with-splittext/, https://gsap.com/resources/fouc/
        onStart: () => {
            // Ensure the loading text is visible at the start of the animation
            gsap.set(loadingText, { autoAlpha: 1 });
        },
        onComplete: () => {
            // Start loading Three.js resources only after the animation is done
            // This prevents main-thread blockage from interfering with the animation
            experience.resources.startLoading();
        },
    });
}

// Resources ready event
experience.resources.on("ready", () => {
    const loadingScreen = document.querySelector(".loading-screen");
    if (loadingScreen) {
        loadingScreen.classList.add("fade-out");
    }

    const controlsContainer = document.querySelector(".controls-container");
    if (controlsContainer) {
        controlsContainer.classList.add("visible");
    }
});

// Camera controls UI
const viewLabel = document.querySelector(".view-label");
const prevBtn = document.querySelector(".arrow.prev");
const nextBtn = document.querySelector(".arrow.next");

if (prevBtn && nextBtn && viewLabel) {
    prevBtn.addEventListener("click", () => {
        const name = experience.camera.changeView("prev");
        viewLabel.textContent = name;
    });

    nextBtn.addEventListener("click", () => {
        const name = experience.camera.changeView("next");
        viewLabel.textContent = name;
    });
}
